import {
  cibGoogleAnalytics,
  cilArrowCircleRight,
  cilBell,
  cilChartLine,
  cilEnvelopeClosed,
  cilEuro,
  cilExitToApp,
  cilExternalLink,
  cilListRich,
  cilMoney,
  cilPeople,
  cilSettings,
} from '@coreui/icons';
import routePaths, { routePatterns } from 'router/route-paths';
import settings from 'config/settings';
import { MEINBAU } from 'constants/constants';

/** A sidebar item, `name` is the message id; an item without `to` is a link that calls `onClick`. */
export interface ISidebarItem {
  name: string;
  to: string;
  /** An icon of @coreui/icons. */
  icon: string[];
  hide?: boolean;
  className?: string;
  onClick?: () => unknown;
}

const sidebarItems: ISidebarItem[] = [
  {
    name: 'page_titles.projects',
    to: routePatterns.projects.stringify({ page: 1 }),
    icon: cilListRich,
  },
  {
    name: 'page_titles.messages',
    to: routePatterns.messages.stringify({ page: 1 }),
    icon: cilEnvelopeClosed,
  },
  {
    name: 'page_titles.loan',
    to: routePaths.loan,
    icon: cilEuro,
  },
  {
    name: 'page_titles.express_loan_settings',
    to: routePaths.expressLoanSettings,
    icon: cilSettings,
  },
  {
    name: 'page_titles.admins',
    to: routePaths.admins,
    icon: cilPeople,
  },
  {
    name: 'page_titles.loan_consultants',
    to: routePaths.loanConsultants,
    icon: cilPeople,
    hide: settings.appName === MEINBAU,
  },
  {
    name: 'page_titles.customer_data_analytics',
    to: routePatterns.customerDataAnalytics.stringify({ page: 1 }),
    icon: cibGoogleAnalytics,
  },
  {
    name: 'page_titles.co2_report',
    to: routePatterns.co2SavingsReport.stringify({ page: 1 }),
    icon: cilChartLine,
  },
  {
    name: 'page_titles.financing_requests',
    to: routePatterns.financingRequests.stringify({ page: 1 }),
    icon: cilMoney,
  },
  {
    name: 'page_titles.hypo_noe_api_requests_report',
    to: routePatterns.hypoNoeApiRequestsReport.stringify({ page: 1 }),
    icon: cilArrowCircleRight,
    hide: settings.appName === MEINBAU,
  },
  {
    name: 'page_titles.reports',
    to: routePaths.reports,
    icon: cilListRich,
  },
  {
    name: 'page_titles.notifications',
    to: routePaths.notifications,
    icon: cilBell,
  },
  {
    name: 'page_titles.analytics',
    to: '',
    icon: cilExternalLink,
    onClick: () => window.open(settings.googleAnalytics, '_blank'),
  },
  {
    name: 'page_titles.logout',
    to: routePaths.logout,
    icon: cilExitToApp,
    className: 'mt-auto',
  },
];

export default sidebarItems;
